var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecordListButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17101",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17101",
    transform: "translate(9537 -9515)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "list-format",
    d: "M10.5,9.4H34.3A1.606,1.606,0,0,0,36,7.7,1.606,1.606,0,0,0,34.3,6H10.5A1.606,1.606,0,0,0,8.8,7.7,1.606,1.606,0,0,0,10.5,9.4Zm23.8,5.1H10.5a1.606,1.606,0,0,0-1.7,1.7,1.606,1.606,0,0,0,1.7,1.7H34.3A1.606,1.606,0,0,0,36,16.2,1.606,1.606,0,0,0,34.3,14.5Zm0,8.5H10.5a1.7,1.7,0,0,0,0,3.4H34.3a1.7,1.7,0,0,0,0-3.4ZM4.892,6.513c-.17-.17-.34-.34-.51-.34a1.552,1.552,0,0,0-1.87.34c-.17.17-.34.34-.34.51a1.877,1.877,0,0,0,0,1.36c.17.17.17.34.34.51s.34.34.51.34a1.022,1.022,0,0,0,.68.17,1.543,1.543,0,0,0,1.19-.51c.17-.17.34-.34.34-.51a1.877,1.877,0,0,0,0-1.36C5.232,6.853,5.062,6.683,4.892,6.513Zm0,8.5a1.552,1.552,0,0,0-1.87-.34c-.17.17-.34.17-.51.34s-.34.34-.34.51a1.862,1.862,0,0,0,0,1.36c.17.17.17.34.34.51s.34.34.51.34a1.022,1.022,0,0,0,.68.17,1.022,1.022,0,0,0,.68-.17c.17-.17.34-.17.51-.34s.34-.34.34-.51a1.862,1.862,0,0,0,0-1.36C5.232,15.351,5.062,15.181,4.892,15.011Zm0,8.5c-.17-.17-.34-.34-.51-.34a1.862,1.862,0,0,0-1.36,0c-.17,0-.34.17-.51.34s-.34.34-.34.51a1.552,1.552,0,0,0,.34,1.87c.17.17.34.34.51.34a1.022,1.022,0,0,0,.68.17,1.022,1.022,0,0,0,.68-.17c.17-.17.34-.17.51-.34a1.552,1.552,0,0,0,.34-1.87C5.232,23.849,5.062,23.679,4.892,23.509Z",
    transform: "translate(-9538.996 9516.003)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15276",
    "data-name": "\\u9577\\u65B9\\u5F62 15276",
    width: 34,
    height: 34,
    transform: "translate(-9537 9515)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordListButton);
export default __webpack_public_path__ + "static/media/recordListButton.18f625c73a26368ca460dc0ebe9d631c.svg";
export { ForwardRef as ReactComponent };